<template>
  <div id="popUpWin">
    <div>
      <div class="cross" v-on:click="closePopUp">
        <cross-icon/>
      </div>
      <h1>Изменение графика платежа</h1>
      <p>Подтвердите перенос даты платежа</p>

      <div class="newDateOfPayment">
        <div>
          <p>Новая дата платежа</p>
          <p>2.12.2024</p>
        </div>
        <div>
          <p>Комиссия за изменение</p>
          <p>500 ₽</p>
        </div>

      </div>
    </div>

    <div class="buttons">
      <button class="whiteButton" v-on:click="setPopUp(4)">Отменить</button>
      <button class="purpleButton" v-on:click="setPopUp(6)">Перенести платёж</button>
    </div>
  </div>
</template>

<script>
import CrossIcon from '@/assets/svg/cross';
export default {
  name: 'accept-new-pay-graph',
  components: { CrossIcon },
  methods: {
    closePopUp () {
      this.$store.commit('closePopUp');
    },
    setPopUp (val) {
      this.$store.commit('popUpVarChange', val);
    }
  }
};
</script>

<style scoped>
#popUpWin { height: calc(165.33vw - 10.67vw); display: flex; flex-direction: column; justify-content: space-between }
#popUpWin>div>h1 { margin-bottom: 1.07vw }
#popUpWin>div>p { font-size: 4vw; margin-bottom: 6.40vw }
#popUpWin>.buttons { display: flex; flex-direction: column }
#popUpWin>.buttons>button { padding: 2.93vw 0 }
#popUpWin>.buttons>.whiteButton { margin-bottom: 2.13vw }
#popUpWin>div>.newDateOfPayment>div { display: flex; justify-content: space-between; align-items: center }
#popUpWin>div>.newDateOfPayment>div:first-child { padding-bottom: 2.13vw; border-bottom: 1px solid rgba(207, 207, 207, 1); margin-bottom: 2.13vw }
#popUpWin>div>.newDateOfPayment>div>p { font-size: 3.73vw }
#popUpWin>div>.newDateOfPayment>div>p:last-child { font-weight: 700; font-size: 4vw }

@media screen and (min-width: 760px) {}

@media screen and (min-width: 1200px) {
  #popUpWin { height: calc(383px - 40px); width: calc(600px - 40px); }
  #popUpWin>div>h1 { margin-bottom: 4px }
  #popUpWin>div>p { font-size: 16px; margin-bottom: 24px }
  #popUpWin>.buttons { flex-direction: row; justify-content: space-between }
  #popUpWin>.buttons>button { padding: 16px 0; width: 100% }
  #popUpWin>.buttons>.whiteButton { margin-bottom: 0; margin-right: 8px }
  #popUpWin>div>.newDateOfPayment>div { display: flex; justify-content: space-between; align-items: center }
  #popUpWin>div>.newDateOfPayment>div:first-child { padding-bottom: 8px; border-bottom: 1px solid rgba(207, 207, 207, 1); margin-bottom: 8px }
  #popUpWin>div>.newDateOfPayment>div>p { font-size: 14px }
  #popUpWin>div>.newDateOfPayment>div>p:last-child { font-weight: 700; font-size: 16px }
}

</style>
